module.exports = "Ext.namespace(\"starfish\"),Ext.BLANK_IMAGE_URL=\"../images/default/s.gif\";"